import { Navigate, useLocation } from 'react-router-dom';

const DeprecatedDailyRedirect: React.FC = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // Keep `/daily` alive as a compatibility redirect while external links migrate.
  if (searchParams.get('layout') !== 'marketing') {
    searchParams.set('layout', 'marketing');
  }

  const search = searchParams.toString();
  const target = `/games/daily-question${search ? `?${search}` : ''}`;

  return <Navigate to={target} replace />;
};

export default DeprecatedDailyRedirect;
